import { FONT } from "../../../value/staticValues";
import { getTimestampToDate, parseLocaleDatetime } from "../../../common/util";

import { ReactComponent as AddButtonImg } from "../../../img/ico-prefix-add.svg";
import { ReactComponent as AddButtonActiveImg } from "../../../img/ico-prefix-add-white.svg";

import { ReactComponent as StatusStableImg} from "../../../img/ico-status-stable.svg";
import { ReactComponent as StatusBlockImg } from "../../../img/ico-status-block.svg";

import VmSubnetAdd from "./VmSubnetAdd";
import VmSubnetUpdate from "./VmSubnetUpdate";

import { DropdownType } from "../../base/CustomDropdown";
import { ListActionMenu, ListFilter, ListTableHeader } from "../../base/table/listTableType";
import { TABLE_ACTION_MENU_TYPE, TABLE_BUTTON_TYPE } from "../../../value/type";

import i18n from "../../../lang/base";

export interface VmSubnetData {
    subnet_id: string,
    subnet_name: string,
    subnet_description: string|null,
    allocated_ip_pools: string,
    dns_nameservers: string,
    host_routes: string,
    cidr: string,
    gateway_ip_address: string,
    inctive_gateway_yn: boolean,
    dhcp_yn: boolean,
    ip_version: number,
    network: {
      network_id: string,
      network_name: string,
      share_type_code: string
    },
    create_ts: string,
    update_ts: string
}
export const actionMenus:ListActionMenu[] = [
    {
        id: 1,
        name: i18n.t("SUBNET_ADD_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH_WITH_ICON,
            code: "SUBNET_ADD",
            imgComponent: <AddButtonImg/> ,
            activeImgComponent: <AddButtonActiveImg />,
            inactiveImgComponent: <AddButtonImg style={{filter: "opacity(0.5) grayscale(0.5)"}}/>,
        },
    },
    {
        id: 2,
        name: i18n.t("DELETE_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.CANCEL,
            code: "SUBNET_DELETE",
        },
    },
    {
        id: 3,
        name: i18n.t("SYNC_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH,
            code: "SUBNET_SYNC",
        }
    }
];



export const tableHeaders:ListTableHeader[] = [
    {
        Header: i18n.t("SUBNET_NAME_TEXT"),
        accessor: "subnet_name",
        disableSortBy: false,
        style: {
            width: "140px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value}</div>)
    },
    {
        Header: "CIDR",
        accessor: "cidr",
        disableSortBy: false,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer,...className.purpleText}}>{value}</div>)
    },
    {
        Header: i18n.t("GATEWAY_IP_TEXT"),
        accessor: "gateway_ip_address",
        disableSortBy: true,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer,...className.resourceContainer}}>{value}</div>)
    },
    {
        Header: i18n.t("USE_DHCP_TEXT"),
        accessor: "dhcp_yn",
        disableSortBy: false,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer,...className.resourceContainer}}>{value ? "Y" : "N"}</div>)
    },
    {
        Header: i18n.t("UPDATE_DATE_TEXT"),
        accessor: "update_ts",
        disableSortBy: false,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer}}>{value ? parseLocaleDatetime(value) : ""}</div>)
    },
    {
        Header: i18n.t("CREATE_DATE_TEXT"),
        accessor: "create_ts",
        disableSortBy: false,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer,...className.dateContainer}}>{value ? parseLocaleDatetime(value) : ""}</div>)
    },
];

export const vmSubnetAddModalContent = {
    title: i18n.t("SUBNET_ADD_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("CREATE_TEXT")
        },
    ],
    innerComponent: <VmSubnetAdd />,
}

export const vmSubnetUpdateModalContent = {
    title: i18n.t("SUBNET_UPDATE_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("UPDATE_SAVE_TEXT")
        },
    ],
    innerComponent: <VmSubnetUpdate />,
}

export const VmNetworkTypeDropdownItem:DropdownType[] = [
    {
        value: "FLAT",
        label: "FLAT"
    },
    {
        value: "VLAN",
        label: "VLAN"
    },
    {
        value: "VXLAN",
        label: "VXLAN"
    }
]

const className = {
    normalTextContainer: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333",
        overflow: "hidden"
    },
    statusImg: {
        marginRight: 3
    },
    dateContainer: {
        color: "#9ea0a5",
    },
    resourceContainer: {
        color: "#0853fb"
    },
    countContainer: {
        color: "#3a8344"
    },
    purpleText: {
        color: "#7066f1"
    },
    greenText: {
        color: "#3a8344"
    }
}